export default "__VITE_ASSET__T8Y2qQc$__"